import { createSelector } from 'reselect';

const selectDomain = (state) => state.attackButton;

export const selectAttacking = createSelector(
  [selectDomain], (state) => state.get('attacking'),
);

